import _ from 'lodash'
import ChartDesignerFeature from './chart-designer-feature'

/**
 * Model for a 'Trend Line' Feature
 * @extends ChartDesignerFeature
 */
const ChartDesignerTrendLine = ChartDesignerFeature.extend(/** @lends ChartDesignerTrendLine.prototype */ {

	/**
	 *
	 * @returns {String} The trend line's serie source id.  Will be null if all series
	 * are selected.
	 *
	 * Could be a tempId or a real id.
	 *
	 * If a new source was selected and not yet saved (and reloaded) the tempId will
	 * hold the correct serieId, which could be a realId or a tempId (of the serie)
	 */
	getSourceSerieId: function() {
		const line = _.get(this.getChildren({type: 'line'}), '[0]', {})
		const {serieSourceId, serieSourceTempId} = line
		return _.isNil(serieSourceTempId) ? serieSourceId : serieSourceTempId
	}

})

export default ChartDesignerTrendLine

ChartDesignerTrendLine.__filename__ = 'charts/model/chart-designer-trend-line.js'
